import { useState } from 'react';

interface ToggleButtonInterface {
  enabled: boolean;
  onChange: Function;
}

export default function ToggleButton({ enabled, onChange }: ToggleButtonInterface) {
  const [on, setOn] = useState(enabled);

  const handleChange = async () => {
    onChange();
    setOn((prev) => !prev);
  };

  return (
    <button
      type="button"
      onClick={handleChange}
      className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors duration-300 ${
        on ? 'bg-green-500' : 'bg-gray-300 dark:bg-gray-600'
      }`}
    >
      <span
        className={`inline-block h-5 w-5 transform rounded-full bg-white shadow transition-transform duration-300 ${
          on ? 'translate-x-5' : 'translate-x-1'
        }`}
      />
    </button>
  );
}
